export default __webpack_public_path__ + "static/media/hrm.d787a298.svg";